import { createAsyncThunk } from '@reduxjs/toolkit'
import User from '../../../models/User'
import authService from '../../../services/auth.service'
import { updateMessage, userUpdate } from './loginSlice'

export const loginAction = createAsyncThunk(
  'user/login',
  async (user: User, { rejectWithValue, dispatch }) => {
    const successCallback = (res: any) => {
      // ✅ Check if response indicates an error (interceptor converts errors to resolved promises)
      if (res.data?.success === false || res.data?.error === true) {
        const errorMessage = res.data?.message || 'Login failed'
        console.log('🔴 Login failed:', errorMessage)
        return rejectWithValue(errorMessage)
      }
      
      // ✅ Guard against undefined data
      if (!res.data?.data) {
        console.log('🔴 Login response missing data')
        return rejectWithValue('Invalid response from server')
      }
      
      const session = res.data.data
      if (session?.loggedInAsSubuser) {
        session.subusers = [
          {
            username: session.loggedInAsSubuser,
            permissions: session.subuserPermissions || {},
          },
        ]
      }
      dispatch(userUpdate(session))
      dispatch(updateMessage({ status: true }))
      dispatch(getUserInfoAction({} as User))
      return res.data
    }
    
    const errorCallback = (e: any) => {
      const errorMessage = e.response?.data?.message || e.message || 'Login failed'
      console.log('🔴 Login error:', errorMessage)
      return rejectWithValue(errorMessage)
    }
    
    if (user.admin) {
      return authService
        .loginAdmin(user)
        .then(successCallback)
        .catch(errorCallback) 
    }
    if (user.affilate) {
      return authService
        .loginAffilate(user)
        .then(successCallback)
        .catch(errorCallback) 
    }
    return authService
      .login(user)
      .then(successCallback)
      .catch(errorCallback)
  },
)

export const getUserInfoAction = createAsyncThunk(
  'user/user-info',
  async (user: User, { rejectWithValue }) => {
    if (authService.getRefreshToken()) {
      return authService
        .getUser()
        .then((res: any) => res.data)
        .catch((e: any) => {
          // ✅ FIX: If 401 error, clear invalid tokens
          if (e.response?.status === 401) {
            console.log('🔒 Invalid or expired token detected - clearing tokens')
            // Clear all tokens
            localStorage.removeItem('token')
            localStorage.removeItem('token-admin')
            localStorage.removeItem('token-affiliate')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('refreshToken-admin')
            localStorage.removeItem('login-session')
            
            // Don't show error on login pages
            const isLoginPage = window.location.pathname.includes('/login') || 
                                window.location.pathname.includes('/dash')
            if (isLoginPage) {
              console.log('ℹ️ Suppressing 401 error on login page')
              return rejectWithValue('silent_401') // Special marker for silent rejection
            }
          }
          return rejectWithValue(e.response?.data?.message || 'Failed to fetch user info')
        })
    }
    return rejectWithValue('Token not exist')
  },
)
